export { default } from '@shikijs/langs/objective-c'
